import { Company } from 'api/models';
import { UserProfileInfo } from 'api/user';

interface CurrentUserStateType {
  currentUser: UserProfileInfo;
  vendorCompany: Company;
}
export class CurrentUserState {
  private _userState: CurrentUserStateType | undefined = undefined;

  get userState(): CurrentUserStateType | undefined {
    return this._userState;
  }

  set userState(value: CurrentUserStateType | undefined) {
    this._userState = value;
  }
}
export const currentUserState = new CurrentUserState();
